<div class="row">
    <div class="col-md-4">
        <infos-list></infos-list>
    </div>
    <div class="col-md-4">
        <objets-list></objets-list>
    </div>
    <div class="col-md-4">
        <dashboard-od-list *ngIf="settings?.odActif"></dashboard-od-list>
    </div>
</div>
<div class="row">
    <div class="col-md-4">
        <dashboard-omp-list *ngIf="settings?.otActif"></dashboard-omp-list>
    </div>
    <div class="col-md-4">
        <dashboard-ndf-list *ngIf="settings?.ndfActif"></dashboard-ndf-list>
    </div>
    <div class="col-md-4">
        <dashboard-avances-list *ngIf="settings?.avActif"></dashboard-avances-list>
    </div>
</div>
